import React from 'react';
import {
  getPagePath,
  withLocales,
  withClientConfig
} from '@spotahome/soyuz/client';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
} from '../../api/traditional-login-client';

const onTraditionalSignupSuccess = () => {
  document.location.reload();
};
const onTraditionalLoginSuccess = () => {
  document.location.reload();
};
const traditionalSignupCB = locale => async (name, email, password) =>
  traditionalSignup({ name, email, password, locale });

const traditionalLoginCB = (email, password) =>
  traditionalLogin({ email, password });
const traditionalForgotPasswordCB = async email => {
  try {
    await traditionalForgotPassword({ email });
  } catch (err) {
    console.log(err);
  }
};

const withModalProps = () => Component =>
  withClientConfig()(
    withLocales()(({ locales, clientConfig, initialAction, ...restProps }) => {
      const landlordLoginLink = getPagePath('landlord-panel');
      const landlordSignupLink = getPagePath('externals.landlord-signup');

      const googleLoginHref = getPagePath('externals.social-login', {
        params: {
          social: 'google'
        },
        query: { locale: locales.current, subscribe: 'no' }
      });

      const facebookLoginHref = getPagePath('externals.social-login', {
        params: {
          social: 'facebook'
        },
        query: { locale: locales.current, subscribe: 'no' }
      });

      return (
        <Component
          {...restProps}
          modalProps={{
            landlordLoginLink,
            landlordSignupLink,
            facebookLinks: {
              login: facebookLoginHref,
              signup: facebookLoginHref
            },
            googleLinks: {
              login: googleLoginHref,
              signup: googleLoginHref
            },
            initialAction,
            termsAndConditionsLink: getPagePath(
              'externals.terms-and-conditions'
            ),
            privacyPoliciesLink: getPagePath('externals.privacy-policies'),
            traditionalSignupCB: traditionalSignupCB(locales.current),
            traditionalLoginCB,
            forgotPasswordCB: traditionalForgotPasswordCB,
            renderTraditionalLogin: clientConfig.featureToggle.traditionalLogin,
            onTraditionalLoginSuccess,
            onTraditionalSignupSuccess,
            ...(restProps.modalProps || {})
          }}
        />
      );
    })
  );
export default withModalProps;
